import { Reducer } from 'redux';
import { Actions } from '../actions/Actions';
import { UserContext } from '../Models/UserProfile';

// TODO: old state should be replacted with AuthenticationStatusState and action should be replaced with AuthenticationAction
export const reducer: Reducer<UserContext> = (
  oldState: UserContext = initialUserProfileState,
  action: any
): UserContext => {
  let newState: UserContext;
  switch (action.type) {
    case Actions.GET_VAC_TENANT:
      newState = { ...oldState };
      break;
    case Actions.SET_VAC_TENANT:
      newState = action.payload;
      break;
    default:
      newState = oldState;
      break;
  }
  return newState;
};

export const initialUserProfileState: UserContext = {
  value: [],
 };

export const getVacTenant = (dispatch: any) => {
  dispatch({
    type: Actions.GET_VAC_TENANT,
  });
};

export const setVacTenant = (payload: UserContext) => (dispatch: any) => {
  dispatch({
    type: Actions.SET_VAC_TENANT,
    payload,
  });
};
